'use client'
import {useState} from 'react'
import Typography from './Typography'
import Chevron from '@svg/chevron.svg'

function Accordion({title, description}: {title: string; description: string}) {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div
      onClick={() => setIsOpen(!isOpen)}
      className="flex flex-col px-6 py-7 border border-gray-200 rounded-lg bg-background z-10 cursor-pointer w-full">
      <div className="flex items-center justify-between ">
        <Typography size="md" className="text-gray-900 font-bold!">
          {title}
        </Typography>
        <Chevron width={20} height={20} className={` transition-all ${isOpen ? '' :"rotate-180"}`} />
      </div>
      <div
        className={`grid overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-3 pt-4 border-t border-gray-200' : 'grid-rows-[0fr] opacity-0'}`}>
        <Typography size="sm" className="text-gray-600 overflow-hidden">
          {description}
        </Typography>
      </div>
    </div>
  )
}

export default Accordion
